import React from 'react';
import HeaderOne from "../header/HeaderOne";
import Home_banner from "../components/Home_banner";
import Home_Service_Section from "../components/Home_Service_Section";
import FooterOne from "../footer/FooterOne";
import HomeAbout from '../components/HomeAbout';
import HomeWorkProcess from '../components/HomeWorkPorcess';
import BrandSection from '../components/BrandSliderOne';
import HomePortfolio from '../components/HomePortfolio';
import FeaturesOne from '../components/FeaturesOne';
import TestimonialOne from '../components/TestimonialOne';
import BlogHome from '../components/BlogHome';

export default function Home() {
	
  	return (
	<>
	
	<HeaderOne />	
	<main>		
		<Home_banner />		
		<HomeAbout/>		
		<Home_Service_Section />		
		<HomeWorkProcess/>	
		<BrandSection/>
		<HomePortfolio/>	
		<FeaturesOne/>
		<TestimonialOne/>
		<BlogHome/>
	</main>
	<FooterOne />
	
</>
  )
}
